import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = BASE ? `${BASE}/api` : null;

export const imgSrc = (src) => (src && src.startsWith("/api/") ? `${BASE}${src}` : src || "");

const list = async (path) => {
  if (!API) return [];
  const res = await axios.get(`${API}${path}`);
  return Array.isArray(res.data) ? res.data : [];
};

export const fetchConcerts = () => list("/concerts");
export const fetchSponsors = () => list("/sponsors");
export const fetchPackages = () => list("/packages");

export const fetchConcert = async (slug) => {
  if (!API) return null;
  const res = await axios.get(`${API}/concerts/${slug}`);
  return res.data ?? null;
};

export const subscribe = (email) => axios.post(`${API}/subscribe`, { email });

export const TOKEN_KEY = "fscs_admin_token";
export const adminApi = axios.create({ baseURL: API || "" });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? `${x.loc?.slice(-1)[0] ?? ""} ${x.msg}`.trim() : JSON.stringify(x))).join(". ");
  return typeof d?.msg === "string" ? d.msg : String(d);
};
